module.exports = __webpack_public_path__ + "static/media/logo-light.709ffee6.png";